const API_URL = process.env.REACT_APP_BACKEND_URL || window.location.origin;

/**
 * Proxies api-sports.io image URLs through our backend (they require API key auth)
 */
export const proxyImageUrl = (url) => {
  if (!url || !API_URL) return url;
  
  // Team badges
  const teamMatch = url.match(/api-sports\.io\/football\/teams\/(\d+)\.png/);
  if (teamMatch) return `${API_URL}/api/proxy/team-image/${teamMatch[1]}`;
  
  // Player photos
  const playerMatch = url.match(/api-sports\.io\/football\/players\/(\d+)\.png/);
  if (playerMatch) return `${API_URL}/api/proxy/player-image/${playerMatch[1]}`;
  
  // League logos
  const leagueMatch = url.match(/api-sports\.io\/football\/leagues\/(\d+)\.png/);
  if (leagueMatch) return `${API_URL}/api/proxy/league-image/${leagueMatch[1]}`;
  
  return url;
};
